/* eslint-disable camelcase */
import { useState } from 'react';

import Warrior from '~/components/war/warrior/Warrior';
import { useGetWarrior } from '~/hooks/game/useGetWarrior';
import { useGetAccount } from '~/hooks/web3/useGetAccount';

export default function BattleBye({
  ownerWarriorId,
}: {
  ownerWarriorId: number;
}) {
  const [isActive, setIsActive] = useState(false);

  const { data: warrior } = useGetWarrior(ownerWarriorId);
  const { data: connectedAccount } = useGetAccount();
  // eslint-disable-next-line no-unused-vars
  const [attack, _setAttack] = useState<string>();

  if (!warrior) {
    return (
      <div className="battle-matchup">
        <div className="battle-matchup__body battle-matchup__body--loading">
          <div className="battle-matchup__revleal-result">
            Loading your bye...
          </div>
        </div>
      </div>
    );
  }

  // set warrior.owner address of current user to allow ens lookup at low level component
  warrior.owner = connectedAccount?.address;

  return (
    <>
      <div
        className="battle-matchup"
        onMouseEnter={() => setIsActive(true)}
        onMouseLeave={() => setIsActive(false)}
      >
        <div className="battle-matchup__body">
          <Warrior
            facing="east"
            warrior={warrior}
            active={isActive}
            attackPreview={attack}
          />
          <div className="battle-matchup__revleal-result  battle-matchup__body--loading battle-matchup__bye">
            <div>
              Luck of the draw. Your Warrior #{warrior.warrior_id} has a bye and
              is automatically advanced to the next round.
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
